import { httpClient } from '../http-client';
import { WeatherParams } from './types';

export const weatherService = () => {
  const client = httpClient();
  const BASE_URL = '/v1/weather-limit-parameters';

  return {
    fetchWeatherParams: async (terminal: string): Promise<WeatherParams[] | null> => {
      const url = `${BASE_URL}/${terminal}`;
      try {
        const result = await client.get<WeatherParams[]>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    createWeatherParam: async (data: WeatherParams): Promise<WeatherParams | null> => {
      try {
        const result = await client.post<WeatherParams>(BASE_URL, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    updateWeatherParam: async (data: WeatherParams): Promise<WeatherParams | null> => {
      const url = `${BASE_URL}/${data.id}`;
      try {
        const result = await client.put<WeatherParams>(url, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    deleteWeatherParam: async (id: string): Promise<{} | null> => {
      const url = `${BASE_URL}/${id}`;
      try {
        const result = await client.delete<{}>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
  };
};

const logger = (message: string): void => console.error(`[Weather Service] ${message}`);
